import { useState } from "react";
import { getConversationStats } from "V2.0/services/conversationService";
import {
  ConversationStats,
  transformConversationStats,
  TransformedConversationStats,
} from "../transformers/conversationStats";
import { AxiosResponse } from "axios";
import { mock } from "../mock/data";

export default function useConversationStats(
  workspaceId: string,
  assistantId: string
) {
  const [conversationStats, setConversationStats] =
    useState<TransformedConversationStats>({
      conversationCountBySource: { sources: [], count: [] },
      outboundCountByCampaignStatus: {},
      callDurationStats: {
        total: 0,
        average: 0,
        callCount: 0,
      },
      lastUpdatedAt: Date.now(),
      isLoading: true,
    });

  const fetchConversationStats = async function ({ startTime, endTime }) {
    setConversationStats((prevConversationStats) => {
      return {
        ...prevConversationStats,
        isLoading: true,
      };
    });
    try {
      const response: AxiosResponse<ConversationStats> =
        await getConversationStats({
          workspaceId,
          assistantId,
          startTime,
          endTime,
        });

      if (response.status === 200) {
        setConversationStats(transformConversationStats(response.data));
      }
    } catch (e) {
      setConversationStats({
        conversationCountBySource: { sources: [], count: [] },
        outboundCountByCampaignStatus: {},
        callDurationStats: {
          total: 0,
          average: 0,
          callCount: 0,
        },
        lastUpdatedAt: Date.now(),
        isLoading: false,
      });
    }
  };

  return {
    conversationStats,
    fetchConversationStats,
  };
}
